<template>
  <fts-client-modal
    :title="formData && formData.name"
    width="90%"
    :full-screen="fullScreen"
    append-container-class="action-page-modal-container"
    append-content-class="action-page-modal-content"
    class="fts-action-page-modal"
    @closed="hidden"
    ref="ftsClientModal"
  >
    <!-- icon -->
    <div
      slot="icon"
      class="action-page-modal-icon"
      v-if="formData && formData.emoji"
    >
      <fts-moji :emoji="formData.emoji" :size="18" />
    </div>
    <!-- actions -->
    <template #actions>
      <fts-btn
        text
        icon
        @click="reload"
      >
        <font-awesome-icon :icon="['fas', 'rotate']" />
      </fts-btn>
      <fts-btn
        text
        icon
        @click="fullScreen=!fullScreen"
      >
        <font-awesome-icon :icon="['fas', 'compress-alt']" v-if="fullScreen" />
        <font-awesome-icon :icon="['fas', 'expand-alt']" v-else />
      </fts-btn>
    </template>
    <!-- body -->
    <template #body>
      <iframe
        frameborder="0"
        :src="formData.url"
        :key="iframeKey"
        @load="iframeLoaded"
        ref="customPageIframe"
      ></iframe>
    </template>
  </fts-client-modal>
</template>

<script>
import LocalStorageService from '../store/LocalStorageService';

import FTSClientModal from './FTSClientModal';
import FTSBtn from './FTSBtn';
import FTSMoji from './FTSMoji';

export default {
  components: {
    "fts-client-modal": FTSClientModal,
    "fts-btn": FTSBtn,
    "fts-moji": FTSMoji
  },
  data: () => ({
    formData: null,
    resolve: null,
    iframeKey: new Date().toISOString(),
    fullScreen: false
  }),
  methods: {
    async show(formData) {
      this.formData = _.cloneDeep(formData);

      if (this.formData.url) {
        if (formData.url.includes('?')) {
          this.formData.url = `${this.formData.url}&token=${LocalStorageService.getAccessToken()}`;
        } else {
          this.formData.url = `${this.formData.url}?token=${LocalStorageService.getAccessToken()}`;
        }
      }

      return new Promise((resolve) => {
        this.resolve = resolve;
        window.addEventListener('message', this.iframeEvent);
        this.$refs.ftsClientModal.show();
      });
    },
    hide() {
      this.$refs.ftsClientModal.close();
    },
    hidden() {
      window.removeEventListener('message', this.iframeEvent);
      this.$emit('hidden');
    },
    reset() {
      Object.assign(this.$data, this.$options.data.apply(this));
    },
    iframeEvent(evt) {
      if (evt.data 
      && (typeof evt.data === 'string' || evt.data instanceof String)
      && evt.data.indexOf('inistate') > -1) {
        try {
          const res = JSON.parse(evt.data);
          this.hide();
          this.resolve && this.resolve(res);
          this.reset();
        } catch(err) {
          console.error(err);
          this.$toasted.error('Something went wrong. Please try again.');
        }
      }
    },
    iframeLoaded() {
      this.$refs.customPageIframe.contentWindow.postMessage(
        JSON.stringify({
          type: 'inistate',
          formData: this.formData.formData
        }), "*"
      );
    },
    reload() {
      this.iframeKey = new Date().toISOString();
    }
  },
  beforeDestroy() {
    window.removeEventListener('message', this.iframeEvent);
  }
}
</script>

<style lang="scss">
.fts-action-page-modal {
  .action-page-modal-icon {
    height: 1.75rem;
    display: flex;
    align-items: center;
  }
  .action-page-modal-container {
    height: 100%;
  }
  .action-page-modal-content {
    padding: 0;
    overflow: hidden !important;
  }
  iframe {
    width: 100%;
    height: 100%;
  }
}
</style>